import { mixpanelApi } from './mixpanel';
import { gtmApi } from './gtm';
import { newRelicApi } from './newRelic';
import { sopaliticsApi } from './sopalitics';
import { asEventName } from './analytics.utils';
let alreadyStarted = false;
const init = ({ newRelic, sopalitics }) => {
    if (alreadyStarted) {
        return;
    }
    sopaliticsApi.init(sopalitics);
    newRelicApi.init(newRelic);
    mixpanelApi.init(process.env.REACT_APP_MIXPANEL_API_KEY);
    gtmApi.init(process.env.REACT_APP_GTM_ID);
    alreadyStarted = true;
};
const updateTracking = (track) => {
    sopaliticsApi.updateTracking(track);
    mixpanelApi.updateTracking(track);
    gtmApi.updateTracking(track);
    newRelicApi.updateTracking(track);
};
const onLogin = (externalId) => {
    sopaliticsApi.onLogin(externalId);
    mixpanelApi.onLogin(externalId);
    gtmApi.onLogin(externalId);
    newRelicApi.onLogin(externalId);
    register({ externalId: externalId });
};
const onLogout = () => {
    sopaliticsApi.onLogout();
    mixpanelApi.onLogout();
    gtmApi.onLogout();
    newRelicApi.onLogout();
    register({ externalId: null });
};
const userChanged = (externalId) => {
    if (externalId) {
        onLogin(externalId);
    }
    else {
        onLogout();
    }
};
const event = (eventOrName, properties = {}) => {
    const eventName = asEventName(eventOrName);
    sopaliticsApi.event(eventName, properties);
    mixpanelApi.event(eventName, properties);
    gtmApi.event(eventName, properties);
    newRelicApi.event(eventName, properties);
};
const register = (properties) => {
    sopaliticsApi.register(properties);
    mixpanelApi.register(properties);
    gtmApi.register(properties);
    newRelicApi.register(properties);
};
const setProperties = (properties) => {
    sopaliticsApi.setProperties(properties);
    mixpanelApi.setProperties(properties);
    gtmApi.setProperties(properties);
    newRelicApi.setProperties(properties);
};
export const analyticsApi = {
    init,
    updateTracking,
    onLogin,
    onLogout,
    userChanged,
    register,
    event,
    setProperties
};
//# sourceMappingURL=analytics.js.map